import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";
import { mergeLocaleCatalogSlices } from "./merge-message-tree";
import { redblueSchemeDetailDesignerPageMessages } from "./pages-scheme-detail-designer";
import { redblueSchemeDetailReadinessPageMessages } from "./pages-scheme-detail-readiness";
import { redblueSchemeDetailShellPageMessages } from "./pages-scheme-detail-shell";
import { redblueSchemeDetailTopologyPageMessages } from "./pages-scheme-detail-topology";

export const redblueSchemeDetailPageMessages: Record<AppLocale, MessageTree> =
  mergeLocaleCatalogSlices([
    redblueSchemeDetailShellPageMessages,
    redblueSchemeDetailDesignerPageMessages,
    redblueSchemeDetailReadinessPageMessages,
    redblueSchemeDetailTopologyPageMessages,
  ]);
